import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#0F2332',
        accent: '#e91e63',
        secondary: '#30b1dc',
        success: '#74BE77',
        info: '#2196F3',
        warning: '#FB8C00',
        error: '#ED5E5E'
      }
    }
  },
  icons: {
    iconfont: 'mdiSvg',
  }
}

export default new Vuetify(opts)
